import { TextWrapper } from './styled';
import { Text } from '@simplywallst/ui-core';

export const ValuationColumnHeaderTooltip = () => (
  <TextWrapper rowGap="8px">
    <Text typography="tiny" color="spaceGray">
      Valuation ratios are used to determine the relative value of a company
      compared to similar companies when applicable.{' '}
    </Text>
    <Text typography="tiny" color="spaceGray">
      Key ratios:
    </Text>
    <span>
      <Text typography="tiny" color="spaceGray">
        <strong>PE</strong> - Price to Earnings
      </Text>
      <Text typography="tiny" color="spaceGray">
        <strong>PS</strong> - Price to Sales
      </Text>
      <Text typography="tiny" color="spaceGray">
        <strong>PB</strong> - Price to Book
      </Text>
    </span>
  </TextWrapper>
);
